import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Store } from "@ngrx/store";
import { environment } from "../../../environments/environment";
import { fetchCountry } from "../../store/country/country.actions";

import { HelperService } from '../helper/helper.service';
import { getCountrySelector } from '../../store/country/country.selectors'

@Injectable({
  providedIn: "root"
})
export class CountryService {
  backendUrl = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private store: Store<{ authToken: string }>
  ) {}


  getCountrySelector() {
    return this.store.select(getCountrySelector);
  }

  fetchCountries(filterOptions) {
    this.store.dispatch(fetchCountry({ filterOptions }));
  }

  getCountry(filterOptions) {
    const queryString = HelperService.generateQueryParams(filterOptions);

    return this.http.get(`${this.backendUrl}/statics/countries?${queryString}`);
  }

}
